import { UnitPrefix } from 'types/GlobalKpiOption'

export const getUnitLabel = (
  unit: string | null,
  unitPrefix: {
    selected: UnitPrefix | null
    options: { value: UnitPrefix; label: string }[]
  },
  equivalentUnit?: string | null
): string => {
  if (unit === '%') {
    return unit
  }

  if (equivalentUnit || equivalentUnit === '') {
    return equivalentUnit
  }

  let parsedUnit = ''

  if (unitPrefix.selected) {
    parsedUnit =
      unitPrefix.options.find((item) => item.value === unitPrefix.selected)
        ?.label || ''
  }

  if (unit) {
    // a converted currency reads "m EUR", kr and SI units "mkr" and "GWh"
    const separator = parsedUnit && /^[A-Z]{3}/.test(unit) ? ' ' : ''

    parsedUnit = parsedUnit + separator + unit
  }

  return parsedUnit
}
